import React from 'react'

import { Link } from 'react-router-dom'

import {
  Container,
  Profile,
  WrapperHeader,
  SLink,
  DivCentral,
  DivIcons,
  Banner,
  Content,
  M,
  Title,
  ImgFaq,
  Relative,
  IconTag,
  DivIconName,
  FirstBanner,
} from './styles'

import PrimaryHeader from '../../../components/primary-header'
import SwitchAvailability from '../../../components/switch-availability'
import Ranking from '../../../components/ranking'
import ContractorCard from '../../../components/contractor-card'
import WelcomeModal from '../../../components/welcome-modal'

import chatImage from '../../../assets/svg/question-answer-line.svg'
import notificationmage from '../../../assets/svg/notification-2-line.svg'
import rightImage from '../../../assets/svg/right.svg'
import rightBlueImage from '../../../assets/svg/rightBlue.svg'
import banner from '../../../assets/png/banner.png'
import bannerDesktop from '../../../assets/png/banner-desktop.png'
import bannerVagas from '../../../assets/png/banner-vagas.png'
import FAQ from '../../../assets/svg/FAQ.svg'
import userIMG from '../../../assets/png/user-profile.png'

import { theme } from '../../../styles/theme'

import { HomeProps } from './props'

import { RoutesEnum, Authority } from '../../../enums'
import { getRoute, LinkBuilder } from '../../../helpers'

const HomeDoctor = ({
  setAvailable,
  available,
  tableDataAll,
  isModalOpen,
  handleModalClose,
  hasNewNotification,
  hasNewMessage,
  recentRequests,
  name,
  rankingData,
  imgUrl,
}: HomeProps): JSX.Element => (
  <Container>
    <WelcomeModal
      isModalOpen={isModalOpen}
      handleCloseModal={handleModalClose}
    />
    <PrimaryHeader>
      <WrapperHeader>
        <DivCentral>
          <DivIconName>
            <Profile
              src={imgUrl ? LinkBuilder.buildAssetsUrl(imgUrl) : userIMG}
              alt="Adicionar imagem"
            />
            <div>
              <div className="doctor-name">{`Olá, Dr(a). ${name}`}</div>
              <SLink
                to={RoutesEnum.PROFILE_DOCTOR}
                style={{ color: `${theme.colors.white}` }}
              >
                <span>Ver perfil</span>
                <img
                  src={rightImage}
                  alt="Redirecionamento para o perfil do usuário"
                />
              </SLink>
            </div>
          </DivIconName>
        </DivCentral>
        <SwitchAvailability available={available} onSwitch={setAvailable} />
        <DivIcons>
          <Link to={RoutesEnum.CHATS_DOCTOR}>
            <img
              src={chatImage}
              alt="icone de redirecionamento para tela do chat"
            />
            {hasNewMessage && <IconTag />}
          </Link>
          <Link
            to={getRoute(RoutesEnum.NOTIFICATIONS, { type: Authority.DOCTOR })}
          >
            <img
              src={notificationmage}
              alt="icone de redirecionamento para tela de notificações de médicos"
            />
            {hasNewNotification && <IconTag style={{ right: 0 }} />}
          </Link>
        </DivIcons>
      </WrapperHeader>
      <Link to={getRoute(RoutesEnum.LIST_CONTESTS_VACANCIES_DOCTOR, { type: Authority.DOCTOR })}>
        <FirstBanner>
          <img src={bannerVagas} alt="" width="100%" />
        </FirstBanner>
      </Link>
    </PrimaryHeader>
    <div />

    <Content>
      <M>
        <Title>
          <span>Suas solicitações</span>
          <SLink
            to={RoutesEnum.REQUESTS_DOCTOR}
            style={{
              color: `${theme.colors.system}`,
              display: recentRequests.length === 0 ? 'none' : 'flex',
            }}
          >
            Ver tudo
            <img
              src={rightBlueImage}
              alt="Ver todas as solicitações"
              color="black"
            />
          </SLink>
        </Title>
        {recentRequests.length === 0 && (
          <p>Aguarde, você ainda não possui nenhuma solicitação de trabalho.</p>
        )}
        <Banner>
          <img
            src={window.innerWidth < 768 ? banner : bannerDesktop}
            alt=""
            width="100%"
          />
        </Banner>
        <div className="card-container">
          {recentRequests.map((contractor: any) => (
            <ContractorCard
              key={`requested-by-contractor-${contractor.id}`}
              imgUrl={
                contractor.document.find((doc: any) => doc.url.startsWith('images/'))?.url
              }
              name={contractor.name}
              city={contractor.address.city}
              availability={contractor.availability.join(', ')}
              chatId={contractor.chatId}
              hasNewMessage={contractor.hasNewMessage}
            />
          ))}
        </div>
      </M>

      <Relative>
        <Link to={getRoute(RoutesEnum.FAQ, { type: Authority.DOCTOR })}>
          <ImgFaq src={FAQ} alt="FAQ" />
        </Link>
        <Ranking rankingData={rankingData} />
      </Relative>
      <M>
        <Title>
          <span>Meu histórico de contratações</span>
          <SLink
            to={RoutesEnum.HIRING_DOCTOR}
            style={{
              color: `${theme.colors.system}`,
              display: tableDataAll.length === 0 ? 'none' : 'flex',
            }}
          >
            Ver tudo
            <img
              src={rightBlueImage}
              alt="Ver histórico de contratos"
              color="black"
            />
          </SLink>
        </Title>
        {tableDataAll.length === 0 && (
          <p>Você ainda não foi contratado na plataforma.</p>
        )}

        <div className="card-container">
          {tableDataAll.map((contractor: any) => (
            <ContractorCard
              key={`contracted-by-contractor-${contractor.id}`}
              imgUrl={
                contractor.document.find((doc: any) => doc.url.startsWith('images/'))?.url
              }
              name={contractor.name}
              city={contractor.address.city}
              availability={contractor.availability.join(', ')}
              chatId={contractor.chatId}
              hasNewMessage={contractor.hasNewMessage}
            />
          ))}
        </div>
      </M>
    </Content>
  </Container>
)
export default HomeDoctor
